<template>
  <b-card class="col-12" no-body>
    <div class="m-2">
      <b-row>
        <b-col cols="12">
          <h4 class="text-center font-weight-bold">
            XÁC THỰC ĐỔI THIẾT BỊ
          </h4>
        </b-col>
      </b-row>
      <b-row class="p-1">
        <b-col cols="12" md="3">
          <b-form-group label="Tìm kiếm">
            <b-form-input
                v-model="filter.search"
                placeholder="Nhập số thuê bao / mã code"
                @keyup.enter="onSearch"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="2">
          <b-form-group label="Từ ngày">
            <flat-pickr
                v-model="filter.fromDate"
                :config="{ dateFormat: 'Y-m-d' }"
                class="form-control bg-white"
                placeholder="Từ ngày"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="2">
          <b-form-group label="Đến ngày">
            <flat-pickr
                v-model="filter.toDate"
                :config="{ dateFormat: 'Y-m-d' }"
                class="form-control bg-white"
                placeholder="Đến ngày"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="2">
          <b-form-group label="Trạng thái">
            <b-form-select v-model="filter.status" :options="statusFilterOptions"/>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="2">
          <b-form-group label="Kết quả khớp khuôn mặt">
            <b-form-select v-model="filter.faceMatchStatus" :options="faceMatchFilterOptions"/>
          </b-form-group>
        </b-col>
        <b-col class="d-flex align-items-end" cols="12" md="auto">
          <b-button class="mb-1" variant="primary" @click="onSearch">
            Tìm kiếm
          </b-button>
          <b-button class="mb-1 ml-1" variant="success" @click="exportExcel">
            Xuất excel
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-tabs v-model="activeTab">
            <b-tab title="Yêu cầu xác thực">
              <vue-good-table
                  :columns="requireFields"
                  :isLoading.sync="isLoading"
                  :line-numbers="true"
                  :pagination-options="{ perPage: 20, enabled: true }"
                  :rows="requireData"
                  :sort-options="{ enabled: false }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'VerifyStatus'">
                    <b-badge :variant="statusBadgeVariant(props.row.VerifyStatus)">
                      {{ statusText(props.row.VerifyStatus) }}
                    </b-badge>
                  </span>
                  <span v-else-if="props.column.field === 'ChangeDeviceDate' && props.row.ChangeDeviceDate">
                    {{ moment(props.row.ChangeDeviceDate).format('DD/MM/YYYY HH:mm:ss')  }}
                  </span>
                  <span v-else-if="props.column.field === 'action'" class="action-container">
                    <b-button
                        v-if="props.row.IsStandardized === 1"
                        :disabled="props.row.IsStandardized !== 1"
                        size="sm"
                        variant="primary"
                        @click="copyVerifyLink(props.row)"
                    >
                      Copy link
                    </b-button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </b-tab>
            <b-tab title="Lịch sử xác thực">
              <vue-good-table
                  :columns="fields"
                  :isLoading.sync="isLoading"
                  :line-numbers="true"
                  :pagination-options="{ perPage: 20, enabled: true }"
                  :rows="tableData"
                  :sort-options="{ enabled: false }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'VerifyStatus'">
                    <b-badge :variant="statusBadgeVariant(props.row.VerifyStatus)">
                      {{ statusText(props.row.VerifyStatus) }}
                    </b-badge>
                  </span>
                  <span v-else-if="props.column.field === 'FaceMatchStatus'">
                    <b-badge :variant="props.row.FaceMatchStatus === 1 ? 'success' : 'danger'">
                      {{ faceMatchText(props.row.FaceMatchStatus) }}
                    </b-badge>
                  </span>
                  <span v-else-if="props.column.field === 'ChangeDeviceDate' && props.row.ChangeDeviceDate">
                    {{ moment(props.row.ChangeDeviceDate).format('DD/MM/YYYY HH:mm:ss')  }}
                  </span>
                  <span v-else-if="props.column.field === 'action'" class="action-container">
                    <b-button size="sm" variant="primary" @click="openDetail(props.row)">
                      Xem chi tiết
                    </b-button>
                  </span>
                  <span v-else>
                    {{ props.formattedRow[props.column.field] }}
                  </span>
                </template>
              </vue-good-table>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </div>

    <b-modal
        id="modalChangeDeviceDetail"
        centered
        hide-footer
        size="lg"
        title="Chi tiết yêu cầu đổi thiết bị"
    >
      <b-row v-if="currentItem">
        <b-col cols="4">
          <div class="text-center mb-2">
            <v-zoomer v-if="currentItem.FrontImage" style="height: 250px">
              <img :src="currentItem.FrontImage" alt="Ảnh mặt trước" class="detail-image"/>
            </v-zoomer>
            <div class="text-center mt-1">Ảnh mặt trước</div>
          </div>
        </b-col>
        <b-col cols="4">
          <div class="text-center mb-2">
            <v-zoomer v-if="currentItem.OldFaceImage" style="height: 250px">
              <img :src="currentItem.OldFaceImage" alt="Ảnh mặt trước" class="detail-image"/>
            </v-zoomer>
            <div class="text-center mt-1">Chân dung cũ</div>
          </div>
        </b-col>
        <b-col cols="4">
          <div class="text-center mb-2">
            <v-zoomer v-if="currentItem.FaceImage" style="height: 250px">
              <img :src="currentItem.FaceImage" alt="Ảnh khuôn mặt" class="detail-image"/>
            </v-zoomer>
            <div class="text-center mt-1">Ảnh khuôn mặt (Score: {{ currentItem.Score }})</div>
          </div>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Mã code">
            <b-form-input :value="currentItem.Code" disabled/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Số thuê bao">
            <b-form-input :value="currentItem.Phone" disabled/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Họ và tên">
            <b-form-input :value="currentItem.FullName" disabled/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Trạng thái xác thực">
            <b-form-input :value="statusText(currentItem.VerifyStatus)" disabled/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Thời gian xác thực">
            <b-form-input :value="currentItem.VerifyDate" disabled/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Kết quả khớp khuôn mặt">
            <b-form-input :value="faceMatchText(currentItem.FaceMatchStatus)" disabled/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Người xác thực">
            <b-form-input :value="currentItem.VerifiedBy" disabled/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Thời điểm đổi thiết bị">
            <b-form-input :value="currentItem.ChangeDeviceDate ? moment(currentItem.ChangeDeviceDate).format('DD/MM/YYYY HH:mm:ss') : ''" disabled/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Imei cũ">
            <b-form-input :value="currentItem.OldImei" disabled/>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Imei mới">
            <b-form-input :value="currentItem.NewImei" disabled/>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Ghi chú">
            <b-form-input v-model="confirmNote" placeholder="Nhập ghi chú xác nhận..."/>
          </b-form-group>
        </b-col>
        <b-col class="d-flex justify-content-end mt-1" cols="12">
          <b-button class="mr-1" variant="secondary" @click="$bvModal.hide('modalChangeDeviceDetail')">
            Đóng
          </b-button>
          <b-button v-if="currentItem.VerifyStatus !== 1" variant="success" @click="onConfirmVerify">
            Xác nhận
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </b-card>
</template>

<script>
import {BBadge, BButton, BCard, BCol, BFormGroup, BFormInput, BFormSelect, BModal, BRow, BTab, BTabs} from "bootstrap-vue";
import {$ctx} from "@themeConfig";
import {VueGoodTable} from "vue-good-table";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import moment from "moment";
import XLSX from "xlsx";
import "@core/scss/vue/libs/vue-good-table.scss";

export default {
  name: "ChangeDeviceVerify",
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BBadge,
    BModal,
    BTabs,
    BTab,
    VueGoodTable,
    flatPickr
  },
  data() {
    return {
      moment:moment,
      isLoading: false,
      activeTab: 0,
      filter: {
        search: "",
        fromDate: "",
        toDate: "",
        status: "",
        faceMatchStatus: ""
      },
      faceMatchFilterOptions: [
        {value: "", text: "Tất cả"},
        {value: 1, text: "Đạt"},
        {value: 0, text: "Không đạt"}
      ],
      statusFilterOptions: [
        {value: "", text: "Tất cả"},
        {value: 0, text: "Chưa xác thực"},
        {value: 1, text: "Đã xác thực"},
        {value: 2, text: "Khóa OC"},
        {value: 3, text: "Khóa 2 chiều"},
        {value: 4, text: "CAN"}
      ],
      tableData: [],
      requireData: [],
      requireFields: [
        {field: "Code", label: "Mã code", tdClass: "text-center"},
        {field: "Phone", label: "Số thuê bao", tdClass: "text-center"},
        {field: "FullName", label: "Họ và tên", tdClass: "text-center"},
        {field: "ChangeDeviceDate", label: "Thời điểm đổi thiết bị", tdClass: "text-center"},
        {field: "OldImei", label: "Imei cũ", tdClass: "text-center"},
        {field: "NewImei", label: "Imei mới", tdClass: "text-center"},
        {field: "VerifyStatus", label: "Trạng thái", tdClass: "text-center"},
        {field: "action", label: "Link xác thực", tdClass: "text-center"}
      ],
      fields: [
        {field: "Code", label: "Mã code", tdClass: "text-center"},
        {field: "Phone", label: "Số thuê bao", tdClass: "text-center"},
        {field: "FullName", label: "Họ và tên", tdClass: "text-center"},
        {field: "ChangeDeviceDate", label: "Thời điểm đổi thiết bị", tdClass: "text-center"},
        {field: "OldImei", label: "Imei cũ", tdClass: "text-center"},
        {field: "NewImei", label: "Imei mới", tdClass: "text-center"},
        {field: "VerifyStatus", label: "Trạng thái", tdClass: "text-center"},
        {field: "VerifyDate", label: "Thời gian xác thực", tdClass: "text-center"},
        {field: "FaceMatchStatus", label: "Kết quả khớp khuôn mặt", tdClass: "text-center"},
        {field: "Score", label: "Tỉ lệ so sánh", tdClass: "text-center"},
        {field: "action", label: "Chi tiết", tdClass: "text-center"}
      ],
      currentItem: null,
      confirmNote: ""
    };
  },
  watch: {
    activeTab() {
      this.onSearch();
    }
  },
  mounted() {
    this.onSearch();
  },
  methods: {
    formatDate(date) {
      return date && moment(date).isValid() ? moment(date).format("DD/MM/YYYY HH:mm") : "";
    },
    statusText(status) {
      const found = this.statusFilterOptions.find(item => item.value === status);
      return found ? found.text : "";
    },
    faceMatchText(status) {
      return status === 1 ? "Đạt" : "Không đạt";
    },
    statusBadgeVariant(status) {
      if (status === 1) return "success";
      if (status === 2 || status === 3) return "danger";
      if (status === 4) return "warning";
      return "secondary";
    },
    exportExcel() {
      let rows;
      let fileName;
      if (this.activeTab === 0) {
        rows = this.requireData.map(item => ({
          "Mã code": item.Code,
          "Số thuê bao": item.Phone,
          "Họ và tên": item.FullName,
          "Thời điểm đổi thiết bị": item.ChangeDeviceDate ? moment(item.ChangeDeviceDate).format("DD/MM/YYYY HH:mm:ss") : "",
          "Imei cũ": item.OldImei,
          "Imei mới": item.NewImei,
          "Trạng thái": this.statusText(item.VerifyStatus)
        }));
        fileName = "YeuCauXacThucDoiThietBi.xlsx";
      } else {
        rows = this.tableData.map(item => ({
          "Mã code": item.Code,
          "Số thuê bao": item.Phone,
          "Họ và tên": item.FullName,
          "Thời điểm đổi thiết bị": item.ChangeDeviceDate ? moment(item.ChangeDeviceDate).format("DD/MM/YYYY HH:mm:ss") : "",
          "Imei cũ": item.OldImei,
          "Imei mới": item.NewImei,
          "Trạng thái": this.statusText(item.VerifyStatus),
          "Thời gian xác thực": item.VerifyDate,
          "Kết quả khớp khuôn mặt": this.faceMatchText(item.FaceMatchStatus),
          "Tỉ lệ so sánh": item.Score
        }));
        fileName = "LichSuXacThucDoiThietBi.xlsx";
      }
      if (!rows.length) {
        this.$toast({
          component: ToastificationContent,
          props: {title: "Không có dữ liệu để xuất", icon: "AlertTriangleIcon", variant: "warning"}
        });
        return;
      }
      const worksheet = XLSX.utils.json_to_sheet(rows);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
      XLSX.writeFile(workbook, fileName);
    },
    onSearch() {
      if (this.activeTab === 0) {
        this.getRequireData();
      } else {
        this.getTableData();
      }
    },
    buildFilterParams() {
      const params = {};
      if (this.filter.search) params.search = this.filter.search;
      if (this.filter.fromDate) params.fromDate = this.filter.fromDate;
      if (this.filter.toDate) params.toDate = this.filter.toDate;
      if (this.filter.status !== "") params.status = this.filter.status;
      if (this.filter.faceMatchStatus !== "") params.faceMatchStatus = this.filter.faceMatchStatus;
      return params;
    },
    async getRequireData() {
      this.isLoading = true;
      try {
        const res = await useJwt.get("change-device/require-list", {params: this.buildFilterParams()});
        this.requireData = res.data.result || [];
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: err.response?.data?.message || "Lấy danh sách thất bại",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
        this.requireData = [];
      } finally {
        this.isLoading = false;
      }
    },
    copyVerifyLink(row) {
      const domain = $ctx.API_URL.includes("itel.dev") ? "https://v3.itel.dev" : "https://itel.vn";
      const link = `${domain}/xac-thuc-thiet-bi?ref=${row.Code}`;
      navigator.clipboard.writeText(link).then(() => {
        this.$toast({
          component: ToastificationContent,
          props: {title: "Đã copy link xác thực!", icon: "CopyIcon", variant: "success"}
        });
      }).catch(() => {
        this.$toast({
          component: ToastificationContent,
          props: {title: "Copy link thất bại", icon: "AlertTriangleIcon", variant: "danger"}
        });
      });
    },
    async getTableData() {
      this.isLoading = true;
      try {
        const res = await useJwt.get("change-device/list", {params: this.buildFilterParams()});
        this.tableData = (res.data.result || []).map(item => ({
          ...item,
          VerifyDate: this.formatDate(item.FaceMatchDate)
        }));
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: err.response?.data?.message || "Lấy danh sách thất bại",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
        this.tableData = [];
      } finally {
        this.isLoading = false;
      }
    },
    openDetail(row) {
      this.currentItem = row;
      this.confirmNote = row.Note || "";
      this.$bvModal.show("modalChangeDeviceDetail");
    },
    async onConfirmVerify() {
      const res = await this.$bvModal.msgBoxConfirm(
          "Bạn có chắc chắn muốn xác nhận yêu cầu đổi thiết bị này?",
          {title: "Xác nhận", size: "sm", centered: true}
      );
      if (!res) return;
      try {
        await useJwt.post("change-device/verify", {
          code: this.currentItem.Code,
          note: this.confirmNote
        });
        this.$toast({
          component: ToastificationContent,
          props: {title: "Xác nhận thành công!", icon: "CheckSquareIcon", variant: "success"}
        });
        this.$bvModal.hide("modalChangeDeviceDetail");
        this.getTableData();
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: err.response?.data?.message || "Xác nhận thất bại",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.action-container {
  display: flex;
  justify-content: center;
}

.detail-image {
  max-width: 100%;
  max-height: 250px;
  object-fit: contain;
}
</style>
